<template>
	<a-card :body-style="{padding: '24px 32px'}" :bordered="false">
		<a-form-model layout="inline" @submit="handleSearch" @submit.native.prevent>
			<a-form-model-item>
				<company-search
					v-model="search.company"
					placeholder="请选择所属公司"
				/>
			</a-form-model-item>
			<a-form-model-item>
          <a-select placeholder="选择状态" v-model="search.status" style="width: 160px;" allowClear>
            <a-select-option
              v-for="item in wTypes"
              :key="item.value"
              :value="item.value">
              {{ item.name }}
            </a-select-option>
          </a-select>
      </a-form-model-item>
			<a-form-model-item>
				<a-range-picker v-model="range"  valueFormat="YYYY-MM-DD" />
			</a-form-model-item>
			<a-form-model-item>
				<a-button
					type="primary"
					html-type="submit"
					icon="search"
				>
					查询
				</a-button>
			</a-form-model-item>
		</a-form-model>
		<a-divider />
		<a-table
        :pagination="pager"
        @change="change"
				:loading="loading"
        :columns="columns"
				:scroll="{y: $store.getters.listTableHeight }"
        :data-source="list"
				rowKey="_id"
        bordered>
			<template slot="user" slot-scope="pk, record">
				<div>
				<a-avatar :src="record.toUser.headimgurl" size="small" style="margin: 0 5px;" />
				{{ record.toUser.nickname }}
				</div>
			</template>
			<template slot="status" slot-scope="record">
				<a-tag color="#108ee9" v-if="record === 0">待审核</a-tag>
				<a-tag color="#87d068" v-if="record === 1">通过</a-tag>
				<a-tag color="#f50" v-if="record === 2">不通过</a-tag>
				<a-tag color="#87d068" v-if="record === 3">转账成功</a-tag>
				<a-tag color="#f50" v-if="record === 4">转账失败</a-tag>
			</template>
			<template slot="action" slot-scope="record">
				<div v-if="record.status === 0">
					<a-popconfirm
						title="确认通过提现审核?"
						ok-text="确认"
						cancel-text="取消"
						@confirm="audit(record._id, '1')"
					>
						<a-button type="primary" size="small">通过</a-button>
					</a-popconfirm>
					<a-divider type="vertical" />
					<a-popconfirm
						title="是否拒绝通过审核?"
						ok-text="确认"
						cancel-text="取消"
						@confirm="audit(record._id, '2')"
					>
						<a-button type="danger" size="small">拒绝</a-button>
					</a-popconfirm>
				</div>
				<div v-else>
					<a-popconfirm
							title="是否转账?"
							ok-text="确认"
							cancel-text="取消"
							@confirm="confirm(record._id)"
						>
							<a-button type="primary" size="small" :disabled="record.status === 3">转账</a-button>
						</a-popconfirm>
						<a-divider type="vertical" />
						<a-popconfirm
							title="是否撤回?"
							ok-text="确认"
							cancel-text="取消"
							@confirm="audit(record._id, '11')"
						>
							<a-button type="danger" size="small" :disabled="record.status === 3">撤回</a-button>
						</a-popconfirm>
				</div>
			</template>
		</a-table>
	</a-card>
</template>

<script>
import { getcompanywithdrawal, withdrawalAudit, withdrawalConfirm } from '@/api/company';
import { mapGetters } from 'vuex';

export default {
  name: 'dialyreport',
  data() {
  	return {
	    list: [],
      pager: {},
	    search: {},
			range: [],
			auditing: false,
	    loading: false,
	  };
  },
  created() {
  	this.getList();
  },
  computed: {
		...mapGetters(['wTypes']),
	  columns() {
	    const isAdmin = this.$store.getters.isSuperAdmin;
      const col = [
	      {
		      title: '#',
		      dataIndex: 'index',
		      customRender: (text, row, index) => index + 1,
		      key: 'index',
		      width: '50px',
	      },
        {
					title: '公司名称',
					width: 90,
          dataIndex: 'company.name',
				},
				{
					title: '上级公司',
					width: 90,
          dataIndex: 'paCompany.name',
        },
	      {
		      title: '提现金额',
					dataIndex: 'amount',
					width: 90,
	        // scopedSlots: { customRender: 'profit' },
				},
				{
          title: '状态',
					dataIndex: 'status',
					width: 90,
					scopedSlots: { customRender: 'status' },
        },
	      {
		      title: '提现用户',
					dataIndex: 'user',
					width: 100,
	        scopedSlots: { customRender: 'user' },
	      },
	      {
					title: '提现名字',
					width: 100,
		      dataIndex: 'reUserName',
	      },
	      {
					title: '发起提现人',
					width: 112,
		      dataIndex: 'createUser.username',
				},
				{
          title: '日期',
          dataIndex: 'ctime',
				},
				{
          title: '描述',
          dataIndex: 'desc',
				},
      ];
      const item = {
				title: '操作',
				key: 'action',
				fixed: 'right',
				width: 170,
				scopedSlots: { customRender: 'action' },
			};
      if (isAdmin) {
				col.push(item);
      }
      return col;
	  },
  },
  methods: {
  	async getList() {
  		this.loading = true;
      this.search.ctimeStart = this.range[0];
      this.search.ctimeEnd = this.range[1];
  		try {
        const { data: { docs, pager } } = await getcompanywithdrawal(this.search);
        this.list = docs;
        this.pager = {
          ...pager,
          showTotal: (total) => `共计 ${total} 条信息`,
        };
	    } catch (e) {
				  console.error(e);
	    }
	    this.loading = false;
	  },
	  handleSearch() {
      this.search.page = 1;
  		this.getList();
	  },
    change(pagination) {
      this.search.page = pagination.current;
      this.getList();
		},
		async audit(id, status) {
			const hide = this.$message.loading('操作中，请勿连续点击', 0);
			const res = await withdrawalAudit(id, status);
			if(res) {
				this.$message.success('操作成功');
				setTimeout(hide, 1000);
				this.getList();
			}
		},
		async confirm(id) {
			const hide = this.$message.loading('操作中，请勿连续点击', 0);
			const res = await withdrawalConfirm(id);
			if(res) {
				this.$message.success('操作成功');
				setTimeout(hide, 1000);
				this.getList();
			}
		},
  },
};
</script>

<style scoped>

</style>
